import { Button } from "@virtual-brain-lib/frontend-design-system/ui";
import { useIsOpen } from "@virtual-brain-lib/frontend-design-system/utils";
import type { MessageToolMailboxData } from "@virtual-brain-lib/types";

import { MailRow } from "./MailRow";
import { ToolCardAllMailsModal } from "./ToolCardAllMailsModal";

const MAX_VISIBLE = 5;

interface ToolCardMailboxListProps {
	readonly messages: MessageToolMailboxData["messages"];
	readonly contentReferenceOffset?: number;
}

export function ToolCardMailboxList({
	messages,
	contentReferenceOffset,
}: ToolCardMailboxListProps) {
	const modal = useIsOpen();

	if (messages.length === 0) {
		return null;
	}

	const visible = messages.slice(0, MAX_VISIBLE);
	const hiddenCount = messages.length - visible.length;

	return (
		<div className="flex flex-col gap-2">
			<div className="flex flex-col">
				{visible.map((message) => (
					<MailRow key={message.id} message={message} />
				))}
			</div>

			{hiddenCount > 0 && (
				<Button
					classNames={{ wrapper: "-ml-1.5 self-start" }}
					color="secondary"
					size="xs"
					variant="ghost"
					onClick={modal.open}
				>
					Show all
				</Button>
			)}

			<ToolCardAllMailsModal
				close={modal.close}
				isOpen={modal.isOpen}
				messages={messages}
				contentReferenceOffset={contentReferenceOffset}
			/>
		</div>
	);
}
